/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store        from '@/store/index';

import {
  DivIcon,
  LayerGroup,
  LeafletEvent,
  marker,
  Marker,
  markerClusterGroup,
  Util,
}                                                     from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IParkingSpotData }                           from '@/interfaces/IParkingSpotData';
import IFeature                                       from '@/interfaces/IFeature';
import { IParkingData }                               from '@/interfaces/IParkingData';
import { IModalData }                                 from '@/services/layers/IModalData';
import { toRaw } from 'vue';
import { IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';
import MapIconsGeneratorService from '../MapIconsGeneratorService';
import IPosition from '@/interfaces/IPosition';

interface MarkerIcon {
  spaceNormal: {
    icon: string;
    state: string;
  };
  spaceDisabled: {
    icon: string;
    state: string;
  };
}

export default class ParkingLayerService extends LayerService {
  protected clusteringConstant = 1;
  protected icoMarker: MarkerIcon = {
    spaceNormal: {
      icon: require(`@/assets/img/icon-layers/single-icons/marker_parking_normal_spot.svg`),
      state: 'normal'
    },
    spaceDisabled: {
      icon: require(`@/assets/img/icon-layers/single-icons/marker_parking_diss_spot.svg`),
      state: 'disabled',
    },
  };

  protected parkingGroups = store.state.parkingGroups.features;

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const title = `${ metaData.name }`;
    const className = this.isOccupied(metaData) ? 'g__color--space-occupied' : 'g__color--space-free';
    const icon = this.isSpaceForDisabled(metaData) ? this.icoMarker.spaceDisabled.icon : this.icoMarker.spaceNormal.icon;

    const modalData: IModalData = {
      title: title,
      content: '',
      navigationPoint: leafletMarker,
      lastUpdate: '',
      icon: icon,
      templateName: 'TemplateModalParkingSpot',
      metaData: metaData,
      iconClassName: className,
    };

    if (!this.isOccupied(metaData)) {
      store.commit('displayModal', modalData);
    }
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.parkingSpots;

    const filterPoints: IFeatureCollection = {
      type: points.type,
      features: points.features
    };

    return this.generateMarkerClusterLayer(filterPoints);
  };

  public createMarker = (position: IPosition, feature: IFeature): Marker => {
    const singleMarker = marker([position.lat, position.lng], {
      icon: new DivIcon({
        html: this.generateHtmlPointTemplate(feature.properties),
        iconSize: [35, 43],
        iconAnchor: [35 / 2, 43],
      }),
      draggable: false,
    });

    singleMarker.on('click', (e) => {
      this.onClick(e, feature.properties, singleMarker);
    });

    return singleMarker;
  };

  generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      maxClusterRadius: 0,
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  isSpaceForDisabled = (metaData: any): boolean => {
    return metaData.category === 'DISABLED' ? true : false;
  }
  isOccupied = (metaData: any): boolean => {
    return metaData.last_status && metaData.last_status.occupied;
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const className = this.isOccupied(metaData) ? 'g__color--space-occupied' : 'g__color--space-free';
    const icon = this.isSpaceForDisabled(metaData) ? this.icoMarker.spaceDisabled.icon : this.icoMarker.spaceNormal.icon;

    const settings: IMarkerIconSettings = {
      className: className,
      insideIcon:  icon,
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  }
}
